import React, {
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from 'react'
import { pick, keys, isArray, omit } from 'lodash-es'
import { useTbViewStore, useAppEx } from '@vt/hooks'
import FormModal from './Modal'

const dealValues = (values) => {
  const obj = {}
  keys(values).forEach((v) => {
    if (v.includes('_otherSelect')) {
      if (values[v] && isArray(values[v])) {
        obj[v] = values[v][0] || null
      } else {
        obj[v] = values[v]
      }
    } else {
      obj[v] = values[v]
    }
  })
  return obj
}
export default forwardRef(({ onSubmit }, ref) => {
  const popupRef = useRef(null)
  const [props, setProps] = useState({})
  const [originalData, setOriginalData] = useState()

  const { getDitto } = useAppEx()
  const { fields, editorConfig, fetchTbDataById, tbData } = useTbViewStore(
    (state) =>
      pick(state, ['fields', 'editorConfig', 'fetchTbDataById', 'tbData'])
  )

  const showLayouts = editorConfig && editorConfig.editorLayouts

  useImperativeHandle(ref, () => {
    return {
      open: (data, needUpdateData, isBatch, config) => {
        setProps({ data, needUpdateData, isBatch, config })
      },
      close: () => {
        if (popupRef.current) {
          popupRef.current.close()
        }
      },
    }
  })

  const onClickSubmit = (values, afterSubmit) => {
    if (props?.config?.optType === 'copy-collector') {
      return onSubmit(omit(values, 'objectId'), {}, afterSubmit)
    }
    return onSubmit(values, props, afterSubmit)
  }

  // 批量
  const updateData = (data, values, refSlugs, afterSubmit) => {
    const refValues = {}
    keys(values).forEach((v) => {
      refValues[v] = values[v].objectId
    })
    const promiseArr = []
    const slugsArr = []
    refSlugs.forEach((v) => {
      const obj = fields.find((f) => f.slug === v)
      if (obj && getDitto(obj.dataFromTbId)) {
        const finalRefsValus = dealValues(values[v])
        promiseArr.push(getDitto(obj.dataFromTbId).updateTbData(finalRefsValus))
        slugsArr.push(v)
      }
    })

    return Promise.all(promiseArr).then(() => {
      onSubmit({ ...data, ...refValues }, props, afterSubmit)
    })
  }

  const onClickBatchSubmit = (data, afterSubmit, values) => {
    const refSlugs = fields.filter((v) => v.type === 'ref').map((v) => v.slug)

    updateData(data, values, refSlugs, afterSubmit)
  }

  useEffect(() => {
    const { data } = props

    if (data) {
      fetchTbDataById(data.objectId).then((res) => {
        setOriginalData(res.originalData || data)
      })
    }
  }, [props])

  useEffect(() => {
    if (originalData && popupRef.current) {
      popupRef.current.open()
    }
  }, [originalData])

  if (!originalData) {
    return null
  }

  return (
    <FormModal
      ref={popupRef}
      title={props?.config?.title || '编辑'}
      isDuplicate={props?.config?.optType === 'duplicate'}
      fieldsLayouts={showLayouts}
      onConfirm={props.isBatch ? onClickBatchSubmit : onClickSubmit}
      data={originalData}
      onCancel={() => {
        popupRef.current.close()
      }}
      detailData={tbData}
      isBatch={props.isBatch}
    />
  )
})
